'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("saisieClassification", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      cible: "@cible"
    },
    template: require("./saisieClassification.html"),
    link: function link($scope, $el, $attrs) {},
    controller: function controller($scope, $q, $http, $modal, $compile, $session, budgetService, contextService, $dialogBox, classificationService, tlTableUtils, $notifications, pageStatus) {
      var urlRoot = '/rest/saisie/champAdditionnel';
      var load = function load() {
        $http.get(urlRoot + "/classificationsPourCible/" + $scope.cible).then(function (response) {
          $scope.classifications = response.data;
          $scope.selectedClassification = tlTableUtils.getNewTableSelection($scope.selectedClassification, $scope.classifications);
          if ($scope.selectedClassification == null && $scope.classifications.length > 0) {
            // idealement ce serait plutôt la première ligne du tableau (peu importe les tris) qu'on voudrait voir sélectionnée
            $scope.selectedClassification = $scope.classifications[0];
          }
        });
      };
      tlTableUtils.fixResize($scope, 'classifications');
      tlTableUtils.fixResize($scope, 'selectedClassification');
      $scope.classificationsTableConfig = {
        source: "classifications",
        selectionScope: $scope,
        allowSelection: true,
        selectionAttribute: "selectedClassification",
        initialSort: ["nom", "asc"],
        columns: [{
          title: "Nom",
          attribute: 'nom',
          template: '<span tl-tooltip="Créé par {{model.metadata.creationUser}} le {{model.metadata.creationDate|dateShort}} ">{{model.nom}}</span>' + '<span class="ml-m" ng-if="model.pseudoType==\'REPARTITION\'">' + '(<i class="fa fa-percent"  tl-tooltip="Répartition en pourcentage sur plusieurs valeurs de la classification"></i>)' + '</span>' + '<span class="ml-m" ng-if="model.pseudoType==\'MULTIPLE\'">' + '(<i class="fa fa-ellipsis-h"  tl-tooltip="Association possible à plusieurs valeurs de la classification"></i>)' + '</span>' + '<i ng-if="model.editable==false" class="fa fa-chevron-circle-up blue ml-m" ' + 'tl-tooltip="Cette classification est définie sur le compte \'{{model.compteNomClient}}\' et ne peut être modifiée que sur ce compte."></i>' + '<i ng-if="model.valeurs.length==0" class="fa fa-warning orange ml-m" tl-tooltip="N\'oubliez pas d\'ajouter des valeurs à cette classification"></i>',
          sortable: true,
          sortType: 'alphanum'
        }, {
          template: '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="edit" tl-tooltip="Editer" ng-click="editClassification(model)"></tl-icon-button>' + '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="delete" tl-tooltip="Supprimer" ng-click="deleteClassification(model)"></tl-icon-button>',
          width: '100px',
          cellClass: 'align-c'
        }]
      };
      $scope.addClassification = function () {
        classificationService.openCreationPopin($scope.cible, $scope.classifications).then(function (response) {
          // pour permettre de sélectionner la classification créée
          $scope.selectedClassification = {
            id: response.id
          };
          load();
          pageStatus.invalidate();
        });
      };
      $scope.editClassification = function (classification) {
        classificationService.openEditionPopin(classification, $scope.classifications).then(function (response) {
          load();
          pageStatus.invalidate();
        });
      };
      $scope.editClassificationValue = function (classification) {
        classificationService.openEditionValeursPopin(classification).then(function () {
          load();
          pageStatus.invalidate();
        });
      };
      $scope.deleteClassification = function (classification) {
        $dialogBox.confirm({
          title: "Suppression d'une classification",
          html: (classification.hasAffectations ? "<span class=\'red\'>Attention : Certaines contreparties sont affectées à cette classification.</span><br>" : "") + "Êtes-vous sûr de vouloir supprimer la classification '" + classification.nom + "' ?"
        }).then(function () {
          classificationService.delete(classification.id).then(function (response) {
            if (response.valid) {
              $notifications.info("Classification " + classification.nom + " supprimée.");
              load();
              pageStatus.invalidate();
            }
          });
        });
      };
      load();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/classification/saisieClassification.js
// module id = 2691
// module chunks = 13